// test1146
(1146 && 0);
